/**
 * organizatorMenu.js — the company menu's "Organizatör" parent and the entries its tiers open (backlog #450, 2026-10-17).
 *
 * The parent (id FirmaOrganizator) has one entry per AREA of the organizer's view of other companies (#446): Standlar, Firmalar,
 * Talepler ve borç, Projeler, Kişiler and Kroki (halls and plans). An entry shows only when the company's tier in that area is
 * MONITOR (İzleme) or AUDIT (Denetim); the Kroki entry also needs the KROKI module at READ and the Kişiler entry the PERSONEL module at READ (#449:
 * People appears only when the interface set's PERSONEL level and the People tier both allow it). No visible entry hides the parent.
 * Pure on purpose (no React, no router): VerticalLayouts/index.js calls it, organizatorMenu.test.js tests it.
 */
import { enAz, SEVIYE } from '../../services/portalService';

export const ORGANIZATOR_ALT_OGELER = {
  FirmaOrganizatorStandlar: 'STANDLAR',
  FirmaOrganizatorFirmalar: 'FIRMALAR',
  FirmaOrganizatorTalepler: 'TALEPLER',
  FirmaOrganizatorProjeler: 'PROJELER',
  FirmaOrganizatorKisiler: 'KISILER',
  FirmaKroki: 'SALONLAR',
};

/** The module an entry needs at READ on top of its area's tier. */
export const ORGANIZATOR_ALT_MODUL = {
  FirmaOrganizatorKisiler: 'PERSONEL',
  FirmaKroki: 'KROKI',
};

/** The organizer parent with only the entries its tiers open, or null when none opens. Any other item is returned as it is. */
export function organizatorOgesi(item, portal) {
  if (item.id !== 'FirmaOrganizator' || !Array.isArray(item.subItems)) return item;
  const altlar = item.subItems.filter((sub) => {
    const alan = ORGANIZATOR_ALT_OGELER[sub.id];
    if (!alan) return true;
    if (!portal?.alan?.(alan)?.gorebilir) return false;
    // WAS (until #449): return sub.id !== 'FirmaKroki' || enAz(portal.seviye('KROKI'), SEVIYE.READ);
    const modul = ORGANIZATOR_ALT_MODUL[sub.id];
    return !modul || enAz(portal.seviye(modul), SEVIYE.READ);
  });
  return altlar.length === 0 ? null : { ...item, subItems: altlar };
}
